import React from "react";

const OPTIONS = [
  { key: "WHATSAPP", title: "WhatsApp", desc: "Get the code in a WhatsApp message", icon: "💬" },
  { key: "SMS", title: "SMS (Mobile)", desc: "Get the code as a text message", icon: "📱" },
  { key: "EMAIL", title: "Email", desc: "Get the code in your inbox", icon: "✉️" },
];

export default function OtpChannelModal({ open, onClose, onSelect, loading }) {
  if (!open) return null;
  return (
    <div style={s.overlay} onClick={onClose}>
      <div style={s.card} onClick={(e) => e.stopPropagation()}>
        <button style={s.close} onClick={onClose}>✕</button>
        <h3 style={s.title}>Send OTP via</h3>
        <p style={s.sub}>Choose how you'd like to receive your verification code.</p>
        {OPTIONS.map((o) => (
          <button
            key={o.key}
            style={s.option}
            disabled={loading}
            onClick={() => onSelect(o.key)}
          >
            <span style={s.icon}>{o.icon}</span>
            <span style={{ textAlign: "left", flex: 1 }}>
              <div style={s.optTitle}>{o.title}</div>
              <div style={s.optDesc}>{o.desc}</div>
            </span>
            <span>›</span>
          </button>
        ))}
      </div>
    </div>
  );
}

const s = {
  overlay: { position: "fixed", inset: 0, background: "rgba(10,20,60,.55)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999 },
  card: { position: "relative", width: 420, maxWidth: "92vw", background: "#fff", borderRadius: 24, padding: 28 },
  close: { position: "absolute", top: 16, right: 16, border: "1px solid #ddd", background: "#f4f5ff", borderRadius: 12, width: 40, height: 40, cursor: "pointer" },
  title: { margin: 0, fontSize: 24, fontWeight: 700, color: "#0f1b4d" },
  sub: { color: "#5b6490", margin: "8px 0 20px" },
  option: { display: "flex", alignItems: "center", gap: 14, width: "100%", padding: 14, marginBottom: 12, background: "#fff", border: "1px solid #e1e4f0", borderRadius: 18, cursor: "pointer" },
  icon: { width: 48, height: 48, borderRadius: 14, background: "#e6ebff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22 },
  optTitle: { fontWeight: 700, color: "#0f1b4d" },
  optDesc: { fontSize: 13, color: "#5b6490" },
};